(function() {
  'use strict';

  angular
    .module('admin.notifications.service', [])
    .factory('NotificationsService', NotificationsService);

  /** @ngInject */
  function NotificationsService($http, $q, API) {

    function list(){
        var defer = $q.defer();

        $http.get(API.API_URL_RPC + 'channels')
            .success(defer.resolve)
            .error(defer.reject);

        return defer.promise;
    }

    function listBundles(id){
        var defer = $q.defer();

        $http.get(API.API_URL + 'sets/' + id + '/bundles')
            .success(defer.resolve)
            .error(defer.reject);

        return defer.promise;
    }

    function listSets(id){
        var defer = $q.defer();

        $http.get(API.API_URL + 'channels/' + id + '/sets')
            .success(defer.resolve)
            .error(defer.reject);

        return defer.promise;
    }

    function listAdminSets(id){
      var defer = $q.defer();

      $http.get(API.API_URL + 'admin/channels/' + id + '/sets')
          .success(defer.resolve)
          .error(defer.reject);

      return defer.promise;
    }

    function send(model){
        var defer = $q.defer();

        $http.post(API.API_URL_RPC + 'push/send', model)
            .success(defer.resolve)
            .error(defer.reject);

        return defer.promise;
    }

    return{
        list: list,
        listAdminSets: listAdminSets,
        send: send,
        listBundles: listBundles,
        listSets: listSets
    };

  }

})();
